import { Component, OnInit,ViewChild } from '@angular/core';
import { emailVerificationStatus } from '../models/emailVerificationStatus';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.css']
})
export class EmailVerificationComponent implements OnInit {
emailVerifyObj:emailVerificationStatus
@ViewChild("verifyForm") form: any;

  constructor( private toastr: ToastrManager,private cs:CucurachaAdminService) {
    this.emailVerifyObj=new emailVerificationStatus()
   }
  show:boolean=false
 
  verifyEmailAddress(){
    this.cs.verifyEmailAddressStatus(this.emailVerifyObj).subscribe((data) => {
      if (data.result) {
        this.show=true
        this.toastr.successToastr(data.message);
        this.form.reset();

      }
     
      else {
        this.toastr.errorToastr(data.message);

      }
    })
    
  }
  ngOnInit(): void {
  }
 

}
